import { api } from '@/lib/api';
import { toast } from 'sonner';

/**
 * Trigger a CSV download from an admin export endpoint. Saves the blob to
 * disk via a hidden anchor, falling back to the URL slug for filename when
 * the server doesn't provide a Content-Disposition header.
 */
export async function downloadAdminCsv(
  endpoint: string,
  fallbackName: string,
  errorLabel = 'export'
): Promise<void> {
  try {
    const { blob, filename } = await api.downloadFile(endpoint);
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = filename ?? fallbackName;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    URL.revokeObjectURL(objectUrl);
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    toast.error(`Failed to download ${errorLabel}: ${message}`);
  }
}
